function parsePostgresArrayLiteral(literal) {
  // Postgres text array literal: {val,val} or {"quoted, with commas","another"}
  const inner = literal.slice(1, -1);
  if (!inner) return [];
  const out = [];
  let current = '';
  let inQuote = false;
  let escaped = false;
  for (let i = 0; i < inner.length; i += 1) {
    const c = inner[i];
    if (escaped) {
      current += c;
      escaped = false;
    } else if (c === '\\') {
      escaped = true;
    } else if (c === '"') {
      inQuote = !inQuote;
    } else if (c === ',' && !inQuote) {
      out.push(current);
      current = '';
    } else {
      current += c;
    }
  }
  out.push(current);
  return out.map((s) => s.trim()).filter(Boolean);
}

export function normalizeCorrectAnswer(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
      if (parsed === null || typeof parsed === 'undefined') return [];
      return [String(parsed)];
    } catch {
      // Postgres array literal: {val1,val2} or {"val, with comma","other"}
      if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
        const parsed = parsePostgresArrayLiteral(trimmed);
        if (parsed.length > 0) return parsed;
      }
      return [trimmed];
    }
  }
  if (value === null || typeof value === 'undefined') return [];
  return [String(value)];
}
